export default "__VITE_ASSET__B2nNwNAr__"